<template>
  <main>
    <a @click.prevent="$router.go(-1)" href="#" class="link-back"><span class="icon-ico-arrow-left"></span> Add New
      Feedback & Complaint</a>
    <FormFeedback v-model="data" @submit="onSubmit" ref="formFeedback" />
  </main>
</template>
<script>
import axios from '@/axios';
import FormFeedback from "@/components/form/feedback";
import { showErrorMessage } from '@/utils';
import { objectToFormData } from '@/utils/formdata';
import structuredClone from 'core-js/actual/structured-clone';

export default {
  components: {
    FormFeedback
  },
  data() {
    return {
      data: {
        date_time: '',
        type: 'Feedback',
        description: '',
        category_id: '',
        priority: '',
        assign_to: '',
        customer_id: '',
        product: '',
        photo: '',
        pic_id: '',
        no_hp_pic: '',
        grade: '',
        location: '',
        lot_no: '',
        shipment_date: '',
        issue: '',
        transporter_id: '',
        no_surat_jalan: '',
        tgl_surat_jalan: '',
        deadline_date: '',
        end_product_application: '',

        // hook
        prepared_by: ''
      },
    }
  },
  methods: {
    async onSubmit() {
      const isValid = await this.$refs.formFeedback.$validator.validateAll();
      if (isValid) {
        try {
          this.$store.dispatch('toggleLoadingProgress', true)
          const clonedData = structuredClone(this.data)
          delete clonedData.prepared_by
          const data = objectToFormData(clonedData)
          await axios.post('/fnc', data, {
            headers: {
              'Content-Type': 'multipart/form-data'
            },
          })
          this.$notify({ type: 'success', text: 'Success adding feedback and complaint' })
          this.$router.push('/feedback')
        } catch (error) {
          showErrorMessage(error)
        } finally {
          this.$store.dispatch('toggleLoadingProgress', false)
        }
      }
    },
  },
  mounted() {
    this.data.prepared_by = this.AppActiveUser?.name
  },
  computed: {
    AppActiveUser() { return this.$store.state.AppActiveUser },
  }
}
</script>

<style></style>
